export default function SocialJavascriptOutline() {
  return (
    <div
      className="ion-icon-social-javascript-outline"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g transform="translate(384 48)">
	<g id="icon-javascript_1_1_">
		<path d="M-192,56.001v197.017c0,41.567-9.644,71.988-28.662,90.417c-17.06,16.53-42.061,24.565-76.431,24.565
			c-12.002,0-25.78-1.496-37.185-3.886l4.09-30.505c7.146,1.269,15.465,2.149,24.774,2.149c21.92,0,37.892-6.459,48.827-19.745
			C-245.27,302.268-240,282.085-240,252.499V56.001H-192 M-176,40.001h-80v212.498c0,52.58-18.032,67.261-49.412,67.261
			c-14.705,0-27.948-2.521-38.25-6.063L-352,375.904c14.7,5.062,37.259,8.096,54.907,8.096C-225.045,384-176,350.129-176,253.02
			V40.001L-176,40.001z"/>
		<path d="M-1.537,48c24.458,0,45.898,3.146,65.1,9.585l-9.581,32.062C40.37,84.142,21.446,78.71-2.504,78.71
			c-18.607,0-34.462,4.584-45.849,13.256c-11.732,8.936-18.194,21.583-18.194,35.613c0,34.974,33.062,48.149,71.347,63.405
			l0.107,0.043l0.108,0.041c26.977,10.299,45.938,22.261,57.969,36.572C74.593,241.451,80,257.543,80,278.284
			c0,25.177-9.333,46.71-26.99,62.274C32.66,358.497,1.593,367.98-36.833,367.98c-28.052,0-54.698-6.427-72.615-13.979l7.593-31.603
			c17.579,7.248,41.882,14.382,69.438,14.382c20.28,0,36.629-4.478,48.591-13.306c12.807-9.45,19.857-23.697,19.857-40.119
			c0-15.348-6.041-27.922-18.469-38.444c-10.157-8.603-24.801-16.048-47.467-24.136c-26.86-9.904-47.359-21.947-60.934-35.795
			C-105.078,170.455-112,153.829-112,134.154c0-24.149,9.831-45.101,28.43-60.591C-63.49,56.839-35.124,48-1.537,48 M-1.537,32
			C-78.98,32-128,75.998-128,134.154c0,50.083,37.751,81.44,92.641,101.665c39.7,14.158,55.392,26.808,55.392,47.539
			c0,22.756-18.139,37.425-52.448,37.425c-31.863,0-60.789-10.64-80.394-21.255v-0.021L-128,362.727
			c18.639,10.638,53.441,21.255,91.167,21.255C53.854,383.98,96,335.43,96,278.284c0-48.55-26.958-79.9-85.278-102.163
			c-43.139-17.191-61.27-26.795-61.27-48.542c0-17.2,15.688-32.869,48.043-32.869c31.846,0,53.744,10.707,66.505,17.291l19.125-64
			C63.125,39.22,36.188,32-1.537,32L-1.537,32z"/>
	</g>
</g>
</svg>
`,
      }}
    />
  )
}
